<template>
  <div 
    v-if="app.allowChat || app.isTeacher()"
    :class="app.getUser()?.permissions.chat ? '' : 'restricted-chat'" class="chat-input"
  >
    <input ref="input" v-model="message" maxlength="300" @keydown.enter="sendMessage" @keydown="userIsTyping" />
    <button
      :class="app.getUser()?.permissions.chat ? '' : 'restricted-chat-send'"
      :title="
        app.getUser()?.permissions.chat ? '' : 'Your chat permission is off, so all chats will only be seen by the teacher(s).'
      "
      @click="sendMessage"
    >
      Send
    </button>
  </div>
</template>

<script setup lang="ts">
import { ref, watch, nextTick } from 'vue';
import { User } from '../models/User';
import { getApp } from '../models/App';

const message = ref('');
const input = ref<HTMLTextAreaElement | null>(null);

const sendMessage = () => {
  if (!message.value.trim()) return;
  console.log('trying to send message');

  const conf = app.connection.currentRoom;

  if (!app.getUser()?.permissions.chat && !app.isTeacher()) {
    app.send(`[typing]0:${conf?.getLocalUserId()}:${app.currentChat}`);

    User.all().forEach((u) => {
      if (u.role === 'teacher' && u.visible) {
        // Teachers that are present get chats routed to them.
        conf?.sendMessage(message.value, u?.id);
      }
    });
  } else {
    app.send(`[typing]0:${conf?.getLocalUserId()}:${app.currentChat}`);
    conf?.sendMessage(message.value, User.get(app.currentChat)?.id);
  }
  app.getUser().isTyping = false;
  message.value = '';
};

const app = getApp();

let isTyping = false;
let typingTimeout = 0;
const userIsTyping = () => {
  const conf = app.connection.currentRoom;
  if (!conf) return;

  if (isTyping) {
    clearTimeout(typingTimeout);
  } else {
    app.send(`[typing]1:${conf.getLocalUserId()}:${app.currentChat}`);
    app.getUser().isTyping = true;
  }

  isTyping = true;
  typingTimeout = window.setTimeout(() => {
    isTyping = false;
    app.send(`[typing]0:${conf.getLocalUserId()}:${app.currentChat}`);
    app.getUser().isTyping = false;
  }, 1000);
};

watch(
  () => app.currentChat,
  (newValue, oldValue) => {
    delete app.chatIndicator[newValue];
    delete app.chatIndicator[oldValue];
    nextTick(() => {
      input.value?.focus();
    });
  },
);
</script>

<style scoped>
.chat-input {
  display: flex;
  padding: 5px;
}

.chat-input > input {
  border: none;
  padding: 3px 6px;
  margin: 0;
  height: 27px;
  line-height: 21px;
  flex-grow: 1;
  background: white;
}

.chat-input > button {
  border: none;
  line-height: 21px;
  padding: 3px 6px;
  background: var(--color-accent-icon);
  margin-left: 3px;
  color: white;
  font-weight: bold;
  border-radius: 3px;
}

.restricted-chat {
  border: 2px solid red;
}

.restricted-chat-send {
  background: red !important;
}
</style>
